import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

const LOGO = "/tilesmate-logo.png";
const SHOWROOM = "https://customer-assets-0z36b82j.emergentagent.net/job_leads-manager-24/artifacts/nw6am1ao_TilesMate-Front.webp";

function GoogleIcon() {
  return (
    <svg className="h-[18px] w-[18px]" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.24 1.4-1.66 4.1-5.5 4.1-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1c1.9 0 3.2.8 3.9 1.5l2.7-2.6C16.9 2.9 14.7 2 12 2 6.9 2 2.8 6.1 2.8 11.9S6.9 21.9 12 21.9c6 0 9.4-4.2 9.4-9.9 0-.6-.06-1-.14-1.5H12z" />
    </svg>
  );
}

export default function Login() {
  const { login, signingIn } = useAuth();
  return (
    <div className="min-h-screen w-full bg-background md:grid md:grid-cols-2">
      {/* Left: auth panel with logo top-left */}
      <div className="relative flex min-h-screen flex-col px-6 py-8 md:min-h-0 md:px-12 md:py-10">
        <img src={LOGO} alt="TilesMate — Elevating Spaces" data-testid="login-logo" className="h-12 w-auto self-start md:h-14" />

        <div className="flex flex-1 items-center">
          <div className="w-full max-w-sm animate-fade-up">
            <h1 className="font-display text-3xl font-extrabold tracking-tight text-ink">Welcome back</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              Sign in with your TilesMate Google account to manage your leads.
            </p>

            <Button
              onClick={login}
              disabled={signingIn}
              data-testid="google-signin-btn"
              className="mt-8 h-12 w-full gap-3 rounded-xl border border-border bg-white text-ink shadow-sm hover:bg-muted hover:text-ink"
            >
              {signingIn ? <Loader2 className="h-4 w-4 animate-spin" /> : <GoogleIcon />}
              <span className="font-semibold">{signingIn ? "Redirecting…" : "Continue with Google"}</span>
            </Button>

            <p className="mt-6 text-xs leading-relaxed text-muted-foreground">
              Access is restricted to invited TilesMate team members. Contact your admin if you can't sign in.
            </p>
          </div>
        </div>

        <p className="hidden text-xs text-muted-foreground md:block">© {new Date().getFullYear()} TilesMate · Leads CRM</p>
      </div>

      {/* Right: showroom photo with tagline */}
      <div className="relative hidden md:block">
        <img src={SHOWROOM} alt="TilesMate showroom storefront" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/20 to-ink/10" />
        <div className="absolute inset-x-0 bottom-0 p-10">
          <h2 className="max-w-md font-display text-3xl font-extrabold leading-tight text-white" data-testid="login-tagline">
            Curating selections.<br />Capturing opportunities.
          </h2>
        </div>
      </div>
    </div>
  );
}
